import type { MovementType } from "../../types";

export const REBOOT_LIVE_ACCESS_PERMISSION = "reboot_live:access";
export const REBOOT_LIVE_TESTING_PERMISSION = "reboot_live:testing";

// Reboot Live (Free Form and Analysis Builder) only supports these movement
// types for now, so functional movement types are excluded.
export const REBOOT_LIVE_SUPPORTED_MOVEMENT_SLUGS = [
  "baseball-hitting",
  "baseball-pitching",
];

export interface RebootLiveMovementTypeOption {
  value: string;
  label: string;
}

export function getRebootLiveMovementTypeOptions(
  movementTypes: MovementType[],
): RebootLiveMovementTypeOption[] {
  return movementTypes
    .filter((movement) =>
      REBOOT_LIVE_SUPPORTED_MOVEMENT_SLUGS.includes(movement.slug),
    )
    .map((movement) => ({
      value: `${movement.id}`,
      label: movement.name,
    }));
}
